import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import { formatToDecimals } from 'lib/helpers/formatting';

type Props = {
	amount: number;
	finalAmount: number;
};

const ExpenseItemHistogram: React.FC<Props> = ({ amount, finalAmount }) => {
	const svgRef = useRef<SVGSVGElement>(null);

	useEffect(() => {
		const svg = d3.select(svgRef.current);
		svg.selectAll('*').remove();

		const height = 200;
		const barWidth = 55;
		const barGap = 60;
		const bottomPadding = 40;
		const maxVal = Math.max(amount, finalAmount);

		const data = [
			{ label: 'Prevista', value: amount, color: '#C2C923' },
			{ label: 'Effettuata', value: finalAmount, color: '#08A2AA' },
		];

		const yScale = d3
			.scaleLinear()
			.domain([0, maxVal])
			.range([0, height - bottomPadding]);

		data.forEach((d, i) => {
			const barHeight = yScale(d.value);
			const x = i * (barWidth + barGap) + 30;
			const y = height - bottomPadding - barHeight;

			svg.append('rect').attr('x', x).attr('y', y).attr('width', barWidth).attr('height', barHeight).attr('fill', d.color);

			svg
				.append('text')
				.text(formatToDecimals(d.value))
				.attr('x', x + barWidth / 2)
				.attr('y', height - bottomPadding + 25)
				.attr('text-anchor', 'middle')
				.attr('font-size', '14px');

			svg
				.append('text')
				.text(d.label)
				.attr('x', x + barWidth / 2)
				.attr('y', height - bottomPadding + 60)
				.attr('text-anchor', 'middle')
				.attr('font-size', '14px');
		});
	}, [amount, finalAmount]);

	return <svg ref={svgRef} width={250} height={220} />;
};

export default ExpenseItemHistogram;
